export default ({ type }) => ['LetterTriggerStartDate', 'LetterTriggerEndDate'].includes(type);
